import React from 'react';

const CompletedStatus = () => {
  return (
    <div className='bg-[#B0E7AE] w-[60px] h-[25px] flex justify-center items-center text-black rounded-[110px] font-[14px] ml-[10px]'>
      Paid
    </div>
  );
};

export default CompletedStatus;
